import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const UserCard = ({ user, onRoleChange }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 flex flex-col gap-2">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
            <Icon name={user.role === 'admin' ? 'Shield' : 'User'} size={22} color="white" />
          </div>
          <div>
            <div className="font-semibold text-lg text-foreground">{user.username}</div>
            <div className="text-xs text-muted-foreground">ID: {user.id}</div>
          </div>
        </div>
        <select
          value={user.role}
          onChange={e => onRoleChange(user.id, e.target.value)}
          className="border rounded px-2 py-1 text-sm"
          disabled={user.isCurrent}
        >
          <option value="user">User</option>
          <option value="admin">Admin</option>
        </select>
      </div>
    </div>
  );
};

export default UserCard;
